import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GlosarioService } from '../../../services/glosario-entidad.service';
import { TableColumn } from '../../../dto/util/table-column';
import { GlosarioEntidadDto } from '../../../dto/glosario-entidad/glosario-entidad.dto';
import { UtilService } from '../../../services/util.service';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { TranslateService } from '@ngx-translate/core';
import { TableAction } from '../../../dto/util/table-action';
import { FormEditarGlosarioComponent } from '../../forms/form-editar-glosario/form-editar-glosario.component';
import { LanguageService } from '../../../services/util/language.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-glosario-entidad',
  templateUrl: './glosario-entidad.component.html',
  styleUrls: ['./glosario-entidad.component.scss'],
})
export class GlosarioEntidadComponent implements OnInit {
  @ViewChild(FormEditarGlosarioComponent)
  formEditarGlosarioComponent!: FormEditarGlosarioComponent;
  @Input() mostrarColumnaEditar = false;
  @Input() ocultarColumnaEntidad = false;
  // Alfabeto para filtrar por letras
  alfabeto: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  filtroActivo = 'Todos';
  columnas: TableColumn[] = [];
  acciones: TableAction[] = [];
  buscarTermino = '';
  glosario: {
    id: number;
    termino: string;
    definicion: string;
    entidadId: number;
    estado: boolean;
    Entidad?: string;
  }[] = [];
  entidadId = 0;

  readonly ID_ENTIDAD_SUPER_MERCANTILES = 8;
  readonly ID_ENTIDAD_SUPERSOCIEDADES = 1;
  readonly ROL_SUPER_ADMIN = 'Superadministrador';

  mostrarEditar = false;

  editarGlosario(event: any) {
    if (event.idAccion == '1') {
      if (this.formEditarGlosarioComponent) {
        this.formEditarGlosarioComponent.editarGlosario(event);
      }
    } else {
      this.cambiarEstado(event);
    }
  }

  crearNuevaPalabra() {
    if (this.formEditarGlosarioComponent) {
      this.formEditarGlosarioComponent.guardarNuevaPalabra();
    }
  }

  cambiarEstado(event: any) {
    this.alertService.confirmacion(this.glosarioText['seguro'], '',
      () => {
        this.glosarioService.cambiarEstadoGlosario(event.item.id).subscribe({
          next: async () => {
            await this.alertService.exito(this.glosarioText['exito']);
            this.buscarGlosario();
          },
          error: async () => {
            await this.alertService.error(this.glosarioText['error']);
          },
        });
      }, () =>{

      }
    );

  }

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  nombreEntidad = '';

  // Multilenguaje
  glosarioText: any = {};
  idiomaActual: string = 'es';

  constructor(
    private readonly glosarioService: GlosarioService,
    private readonly utilService: UtilService,
    private readonly translate: TranslateService,
    private readonly languageService: LanguageService,
    private readonly alertService: AlertaModalService
  ) { }

  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();
    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
      this.cargarGlosarioInicial();
    });
    const userTypeString = sessionStorage.getItem('user_type'); // O sessionStorage.getItem('user_type')

    if (userTypeString) {
      try {
        const userType = JSON.parse(userTypeString);
        if (userType.Nombre == this.ROL_SUPER_ADMIN) {
          this.mostrarEditar = true;
        } else {
          this.mostrarEditar = false;
        }
      } catch (error) {
        console.error('Error al parsear user_type:', error);
      }
    }

    // Multilenguaje
    this.translate.stream('glosario').forEach(text => {
      for (let key of Object.keys(text)) {
        this.glosarioText[key] = text[key];
      }
      this.inicializarColumnas();
    });
    this.entidadId = this.utilService.idEntidad.value;
    this.utilService.watchIdEntidad().subscribe(valor => {
      this.entidadId = valor;
    });

    if (this.entidadId == this.ID_ENTIDAD_SUPER_MERCANTILES) {
      this.entidadId = this.ID_ENTIDAD_SUPERSOCIEDADES;
    }
    this.cargarGlosarioInicial();
    this.changueNameEntidad(this.entidadId);
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: 'Glosario jurídico',
      descripcionPantalla:
        'En esta pantalla usted podrá buscar y visualizar conceptos jurídicos relacionados a la ' +
        'gestión de los expedientes de las distintas entidades',
      pasos: [],
    };
    this.utilService.changeInfoPantalla(this.infoPantalla);
  }

  private cargarGlosarioInicial(): void {
    this.glosarioService
      .obtenerGlosario({
        entidadId: this.entidadId == 0 ? undefined : this.entidadId,
        idioma: this.idiomaActual,
      })
      .subscribe((data: GlosarioEntidadDto[]) => {
        this.glosario = data.map(item => ({
          id: item.Id,
          termino: item.Termino,
          definicion: item.Definicion,
          entidadId: item.Entidad_Id,
          estado: item.Estado,
          Entidad: item.Entidad?.Entidad,
        }));
      });
  }

  private inicializarColumnas() {
    this.columnas = [
      {
        field: 'termino',
        title: this.glosarioText['concepto'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '12rem',
      },
      {
        field: 'definicion',
        title: this.glosarioText['definicion'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '32rem',
      },
    ];
    // Agregar acciones solo si `mostrarEditar` es true
    this.acciones = this.mostrarEditar
      ? [
        {
          type: 'button',
          icon: 'edit',
          title: this.glosarioText['editar_glosario'],
          idAccion: '1',
        },
        {
          type: 'button',
          icon: 'power-off ',
          title: this.glosarioText['cambiar_estado'],
          idAccion: '2',
        },
      ]
      : [];

    if (!this.ocultarColumnaEntidad) {
      this.columnas.push({
        field: 'Entidad',
        title: this.glosarioText['entidad'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '6rem',
      });
    }
  }

  // Metodo para filrar el glosario
  filtrarGlosario(letter: string): void {
    this.filtroActivo = letter;
    this.buscarGlosario();
  }

  buscarGlosario(): void {
    let filtro: {
      letra?: string;
      estado?: boolean;
      entidadId?: number;
      termino?: string;
      idioma?: string;
    } = {};

    if (this.filtroActivo !== 'Todos') {
      filtro.letra = this.filtroActivo.toLowerCase();
      filtro.estado = true;
    }

    // Si se ha ingresado un término de búsqueda
    if (this.buscarTermino) {
      // Combinar el filtro de búsqueda con el filtro por letra, si aplica
      filtro.termino = this.buscarTermino.toLowerCase();
      filtro.estado = true; // Asegurarse de que el estado también esté activo
    }

    filtro.entidadId = this.entidadId == 0 ? undefined : this.entidadId;
    filtro.idioma = this.idiomaActual;
    this.glosarioService
      .obtenerGlosario(filtro)
      .subscribe((data: GlosarioEntidadDto[]) => {
        this.glosario = data.map(item => ({
          id: item.Id,
          termino: item.Termino,
          definicion: item.Definicion,
          entidadId: item.Entidad_Id,
          estado: item.Estado,
          Entidad: item.Entidad?.Entidad,
        }));
      });
  }

  changueNameEntidad(idEntidad: number) {
    switch (idEntidad) {
      case 0:
        this.nombreEntidad = '';
        break;
      case 1:
        this.nombreEntidad = this.glosarioText['lista_entidades'][0];
        break;
      case 2:
        this.nombreEntidad = this.glosarioText['lista_entidades'][1];
        break;
      case 3:
        this.nombreEntidad = this.glosarioText['lista_entidades'][2];
        break;
      case 4:
        this.nombreEntidad = this.glosarioText['lista_entidades'][3];
        break;
      case 5:
        this.nombreEntidad = this.glosarioText['lista_entidades'][4];
        break;
      case 6:
        this.nombreEntidad = this.glosarioText['lista_entidades'][5];
        break;
      case 7:
        this.nombreEntidad = this.glosarioText['lista_entidades'][6];
        break;
      case 8:
        this.nombreEntidad = this.glosarioText['lista_entidades'][7];
        break;
    }
  }
}
